import { useState, useEffect } from 'react'

export const useDesignPixel = () => {
  const [designPixelValue, setDesignPixelValue] = useState(16)

  useEffect(() => {
    const getDesignPixel = () => {
      const rootStyles = getComputedStyle(document.documentElement)
      const maxWidth =
        parseFloat(rootStyles.getPropertyValue('--max-width').trim()) || 500
      const designWidth =
        parseFloat(rootStyles.getPropertyValue('--design-width').trim()) || 375
      const screenWidth = window.innerWidth

      const width = Math.min(maxWidth, screenWidth)
      const designPixelValue = width / designWidth

      setDesignPixelValue(designPixelValue)
    }

    getDesignPixel()
    window.addEventListener('resize', getDesignPixel)

    return () => window.removeEventListener('resize', getDesignPixel)
  }, [])

  return {
    designPixelValue,
  }
}
